/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoticeDto } from '../../models/notice-dto';

export interface NoticeControllerFindAllV1$Params {
}

export function noticeControllerFindAllV1(http: HttpClient, rootUrl: string, params?: NoticeControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NoticeDto>>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NoticeDto>>;
    })
  );
}

noticeControllerFindAllV1.PATH = '/api/v1/notice';
